export const staticCompliancePieChartData = [
  {
    month: "January",
    overallComplianceCityCount: [
      {
        category: "Completed",
        count: 1,
      },
    ],
    totalCount: 1,
  },
  {
    month: "February",
    overallComplianceCityCount: [
      {
        category: "Completed",
        count: 4,
      },
    ],
    totalCount: 4,
  },
  {
    month: "March",
    overallComplianceCityCount: [
      {
        category: "Completed",
        count: 0,
      },
    ],
    totalCount: 0,
  },
  {
    month: "April",
    overallComplianceCityCount: [
      {
        category: "Completed",
        count: 3,
      },
    ],
    totalCount: 3,
  },
  {
    month: "May",
    overallComplianceCityCount: [
      {
        category: "Completed",
        count: 2,
      },
    ],
    totalCount: 2,
  },
  {
    month: "June",
    overallComplianceCityCount: [
      {
        category: "Completed",
        count: 4,
      },
    ],
    totalCount: 4,
  },
];

export const staticNonComplianceBuildingData = [
  {
    buildingRecords: [
      {
        buildingName: "JNS",
        numberOfObservation: 14,
        buildingDetails: [
          {
            completed: 14,
            pending: 0,
          },
        ],
        compliance: "100 %",
      },
    ],
  },
  {
    buildingRecords: [
      {
        buildingName: "LIC",
        numberOfObservation: 18,
        buildingDetails: [
          {
            completed: 18,
            pending: 0,
          },
        ],
        compliance: "100 %",
      },
    ],
  },
  {
    buildingRecords: [
      {
        buildingName: "STT Data Center",
        numberOfObservation: 14,
        buildingDetails: [
          {
            completed: 14,
            pending: 0,
          },
        ],
        compliance: "100 %",
      },
    ],
  },
  {
    buildingRecords: [
      {
        buildingName: "Dalal Street",
        numberOfObservation: 22,
        buildingDetails: [
          {
            completed: 20,
            pending: 2,
          },
        ],
        compliance: "91 %",
      },
    ],
  },
  {
    buildingRecords: [
      {
        buildingName: "SBI",
        numberOfObservation: 24,
        buildingDetails: [
          {
            completed: 22,
            pending: 2,
          },
        ],
        compliance: "92 %",
      },
    ],
  },
  {
    buildingRecords: [
      {
        buildingName: "Hotel Grand Mercure",
        numberOfObservation: 15,
        buildingDetails: [
          {
            completed: 12,
            pending: 3,
          },
        ],
        compliance: "80 %",
      },
    ],
  },
  {
    buildingRecords: [
      {
        buildingName: "GIFT Two",
        numberOfObservation: 23,
        buildingDetails: [
          {
            completed: 19,
            pending: 4,
          },
        ],
        compliance: "82 %",
      },
    ],
  },
  {
    buildingRecords: [
      {
        buildingName: "GIFT One",
        numberOfObservation: 37,
        buildingDetails: [
          {
            completed: 30,
            pending: 7,
          },
        ],
        compliance: "81 %",
      },
    ],
  },
  {
    buildingRecords: [
      {
        buildingName: "Fintech One",
        numberOfObservation: 14,
        buildingDetails: [
          {
            completed: 11,
            pending: 3,
          },
        ],
        compliance: "79 %",
      },
    ],
  },
  {
    buildingRecords: [
      {
        buildingName: "GIFT City Club",
        numberOfObservation: 15,
        buildingDetails: [
          {
            completed: 11,
            pending: 4,
          },
        ],
        compliance: "67 %",
      },
    ],
  },
  {
    buildingRecords: [
      {
        buildingName: "Janadhar Mangala Society",
        numberOfObservation: 20,
        buildingDetails: [
          {
            completed: 10,
            pending: 10,
          },
        ],
        compliance: "50 %",
      },
    ],
  },
  {
    buildingRecords: [
      {
        buildingName: "ATS Savvy",
        numberOfObservation: 19,
        buildingDetails: [
          {
            completed: 18,
            pending: 1,
          },
        ],
        compliance: "95 %",
      },
    ],
  },
  {
    buildingRecords: [
      {
        buildingName: "Hiranandani Signature",
        numberOfObservation: 17,
        buildingDetails: [
          {
            completed: 15,
            pending: 2,
          },
        ],
        compliance: "88 %",
      },
    ],
  },
  {
    buildingRecords: [
      {
        buildingName: "BIFC",
        numberOfObservation: 14,
        buildingDetails: [
          {
            completed: 11,
            pending: 3,
          },
        ],
        compliance: "78 %",
      },
    ],
  },
];

export const staticDeveloperBuildingOptions = [
  { label: "JNS", value: 1 },
  { label: "LIC", value: 2 },
  { label: "STT Data Center", value: 3 },
  { label: "Dalal Street", value: 4 },
  { label: "SBI", value: 5 },
  { label: "Hotel Grand Mercure", value: 6 },
  { label: "GIFT Two", value: 7 },
  { label: "GIFT One", value: 8 },
  { label: "Fintech One", value: 9 },
  { label: "GIFT City Club", value: 10 },
  { label: "Janadhar Mangala Society", value: 11 },
  { label: "ATS Savvy", value: 12 },
  { label: "Hiranandani Signature", value: 13 },
  { label: "BIFC", value: 14 },
];

export const staticComplianceRateOverTime = {
  1: [
    {
      category: "FirstHalf",
      count: 5,
    },
    {
      category: "SecondHalf",
      count: 0,
    },
  ],
  2: [
    {
      category: "FirstHalf",
      count: 5,
    },
    {
      category: "SecondHalf",
      count: 0,
    },
  ],
  3: [
    {
      category: "FirstHalf",
      count: 5,
    },
    {
      category: "SecondHalf",
      count: 0,
    },
  ],
  4: [
    {
      category: "FirstHalf",
      count: 5,
    },
    {
      category: "SecondHalf",
      count: 0,
    },
  ],
  5: [
    {
      category: "FirstHalf",
      count: 5,
    },
    {
      category: "SecondHalf",
      count: 0,
    },
  ],
  6: [
    {
      category: "FirstHalf",
      count: 5,
    },
    {
      category: "SecondHalf",
      count: 0,
    },
  ],
  7: [
    {
      category: "FirstHalf",
      count: 5,
    },
    {
      category: "SecondHalf",
      count: 0,
    },
  ],
  8: [
    {
      category: "FirstHalf",
      count: 5,
    },
    {
      category: "SecondHalf",
      count: 0,
    },
  ],
  9: [
    {
      category: "FirstHalf",
      count: 5,
    },
    {
      category: "SecondHalf",
      count: 0,
    },
  ],
  10: [
    {
      category: "FirstHalf",
      count: 5,
    },
    {
      category: "SecondHalf",
      count: 0,
    },
  ],
  11: [
    {
      category: "FirstHalf",
      count: 5,
    },
    {
      category: "SecondHalf",
      count: 0,
    },
  ],
  12: [
    {
      category: "FirstHalf",
      count: 5,
    },
    {
      category: "SecondHalf",
      count: 0,
    },
  ],
  13: [
    {
      category: "FirstHalf",
      count: 5,
    },
    {
      category: "SecondHalf",
      count: 0,
    },
  ],
  14: [
    {
      category: "FirstHalf",
      count: 5,
    },
    {
      category: "SecondHalf",
      count: 0,
    },
  ],
};

export const staticInspectionObservationBuildings = {
  1: [
    {
      category: "Number Of Observation",
      count: 14,
    },
    {
      category: "Completed",
      count: 14,
    },
    {
      category: "Pending",
      count: 0,
    },
  ],
  2: [
    {
      category: "Number Of Observation",
      count: 18,
    },
    {
      category: "Completed",
      count: 18,
    },
    {
      category: "Pending",
      count: 0,
    },
  ],
  3: [
    {
      category: "Number Of Observation",
      count: 14,
    },
    {
      category: "Completed",
      count: 14,
    },
    {
      category: "Pending",
      count: 0,
    },
  ],
  4: [
    {
      category: "Number Of Observation",
      count: 22,
    },
    {
      category: "Completed",
      count: 20,
    },
    {
      category: "Pending",
      count: 2,
    },
  ],
  5: [
    {
      category: "Number Of Observation",
      count: 24,
    },
    {
      category: "Completed",
      count: 22,
    },
    {
      category: "Pending",
      count: 2,
    },
  ],
  6: [
    {
      category: "Number Of Observation",
      count: 15,
    },
    {
      category: "Completed",
      count: 12,
    },
    {
      category: "Pending",
      count: 3,
    },
  ],
  7: [
    {
      category: "Number Of Observation",
      count: 23,
    },
    {
      category: "Completed",
      count: 19,
    },
    {
      category: "Pending",
      count: 4,
    },
  ],
  8: [
    {
      category: "Number Of Observation",
      count: 37,
    },
    {
      category: "Completed",
      count: 30,
    },
    {
      category: "Pending",
      count: 7,
    },
  ],
  9: [
    {
      category: "Number Of Observation",
      count: 14,
    },
    {
      category: "Completed",
      count: 11,
    },
    {
      category: "Pending",
      count: 3,
    },
  ],
  10: [
    {
      category: "Number Of Observation",
      count: 15,
    },
    {
      category: "Completed",
      count: 11,
    },
    {
      category: "Pending",
      count: 4,
    },
  ],
  11: [
    {
      category: "Number Of Observation",
      count: 20,
    },
    {
      category: "Completed",
      count: 10,
    },
    {
      category: "Pending",
      count: 10,
    },
  ],
  12: [
    {
      category: "Number Of Observation",
      count: 19,
    },
    {
      category: "Completed",
      count: 18,
    },
    {
      category: "Pending",
      count: 1,
    },
  ],
  13: [
    {
      category: "Number Of Observation",
      count: 17,
    },
    {
      category: "Completed",
      count: 15,
    },
    {
      category: "Pending",
      count: 2,
    },
  ],
  14: [
    {
      category: "Number Of Observation",
      count: 14,
    },
    {
      category: "Completed",
      count: 11,
    },
    {
      category: "Pending",
      count: 3,
    },
  ],
};

export const staticCommonInspectionBarChart = [
  {
    category: "Fire Hydrant System",
    count: 14,
  },
  {
    category: "Fire Sprinkler System",
    count: 14,
  },
  {
    category: "Fire Pumps",
    count: 14,
  },
  {
    category: "Fire Alarm & Detection System",
    count: 14,
  },
  {
    category: "Fire Extinguishers",
    remarks: "Except STT Data Center",
    count: 13,
  },
  {
    category: "Signages",
    count: 13,
    remarks: "Except BIFC",
  },
  {
    category: "Fire Tender Path",
    remarks:
      "STT Data Center GIFT One, GIFT Two, Grand Mercure, Fintech One, SBI",
    count: 6,
  },
  {
    category: "Storage of Combustible Material",
    count: 4,
    remarks: "GIFT One, GIFT Two, Fintech One, Hiranandani",
  },
  {
    category: "Gas Leak Detection System",
    remarks: "Gift City Club, Grand Mercure, Jamnabai Narsee School",
    count: 3,
  },
];

export const staticInspectionStatusMonthWise = [
  {
    month: "January",
    overallComplianceCityCount: [
      {
        category: "Completed",
        count: 1,
      },
    ],
    totalCount: 1,
  },
  {
    month: "February",
    overallComplianceCityCount: [
      {
        category: "Completed",
        count: 4,
      },
    ],
    totalCount: 4,
  },
  {
    month: "March",
    overallComplianceCityCount: [
      {
        category: "Completed",
        count: 0,
      },
    ],
    totalCount: 0,
  },
  {
    month: "April",
    overallComplianceCityCount: [
      {
        category: "Completed",
        count: 3,
      },
    ],
    totalCount: 3,
  },
  {
    month: "May",
    overallComplianceCityCount: [
      {
        category: "Completed",
        count: 2,
      },
    ],
    totalCount: 2,
  },
  {
    month: "June",
    overallComplianceCityCount: [
      {
        category: "Completed",
        count: 4,
      },
    ],
    totalCount: 4,
  },
];
